var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFaqPlusIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.125 6.5625H10.0625V1.5C10.0625 0.902344 9.53516 0.375 8.9375 0.375H7.8125C7.17969 0.375 6.6875 0.902344 6.6875 1.5V6.5625H1.625C0.992188 6.5625 0.5 7.08984 0.5 7.6875V8.8125C0.5 9.44531 0.992188 9.9375 1.625 9.9375H6.6875V15C6.6875 15.6328 7.17969 16.125 7.8125 16.125H8.9375C9.53516 16.125 10.0625 15.6328 10.0625 15V9.9375H15.125C15.7227 9.9375 16.25 9.44531 16.25 8.8125V7.6875C16.25 7.08984 15.7227 6.5625 15.125 6.5625Z",
    fill: "#2AA7FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFaqPlusIcon);
export default __webpack_public_path__ + "static/media/FAQ_plus_icon.e2bb41a29d175e9d42757c80952c4525.svg";
export { ForwardRef as ReactComponent };